"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchyService = exports.HIERARCHY_TYPE = void 0;
/* eslint-disable no-prototype-builtins */
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var SearchResultsService_1 = require("./SearchResultsService");
var HIERARCHY_SEPARATOR = '%40'; // encoded
var TITLE_SEPARATOR = '@'; // not encoded
var DEFAULT_LEVEL_LABEL = 'Level ';
var segmentHierarchyMap = {
    'documentationSegment:cf': ['byCategory'],
    'documentationSegment:dps': ['productGroup', 'productFamily', 'productType'],
    'drawingsSegment:cf': ['byCategory'],
    'drawingsSegment:dps': ['productGroup', 'productFamily', 'productType'],
};
var ALLOWED_DOCUMENTS_FILTERS = [
    FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationSegmentFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
    FullTextSearchApi_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
];
exports.HIERARCHY_TYPE = {
    marketingHierarchy: 'Marketing hierarchy',
    productHierarchy: 'Product hierarchy',
    withoutHierarchy: 'None',
};
var HierarchyService = /** @class */ (function () {
    function HierarchyService() {
        var _this = this;
        this.resolveHierarchy = function (hierarchyFilter, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel, skipFirstLevelAndLabel) {
            if (hierarchyDictionaryLabel === void 0) { hierarchyDictionaryLabel = ''; }
            if (skipFirstLevelAndLabel === void 0) { skipFirstLevelAndLabel = false; }
            var hierarchy = _this.parseHierarchy(hierarchyFilter, skipFirstLevelAndLabel);
            var selectedHierarchyFilterArray = _this.getSelectedHierarchyFilter(hierarchyFilter.items, skipFirstLevelAndLabel);
            var hierarchyDropdowns = [];
            if (selectedHierarchyFilterArray && selectedHierarchyFilterArray.length) {
                _this.recursivelyBuildFilterDropdownsFromHierarchyTree(hierarchy, selectedHierarchyFilterArray, hierarchyDropdowns, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel);
            }
            var dropdownLabel = _this.getTitleFromMap(0, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel);
            var dropdownModel = {
                guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
                isCollapsed: false,
                isDisabled: false,
                isHidden: false,
                title: dropdownLabel,
                typeAlias: hierarchyTypeAlias,
                value: dropdownLabel,
            };
            if (!skipFirstLevelAndLabel) {
                dropdownModel.label = hierarchyFilter.label;
            }
            var dropdownOptions = [];
            for (var option in hierarchy) {
                if (!hierarchy.hasOwnProperty(option)) {
                    continue;
                }
                var _a = hierarchy[option], _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                var parsedTitle = title.split(TITLE_SEPARATOR).pop();
                dropdownOptions.push({ title: parsedTitle, value: value, selected: false, documentsCount: 1 });
            }
            dropdownModel.items = dropdownOptions;
            hierarchyDropdowns.unshift(dropdownModel);
            selectedHierarchyFilterArray = _this.getSelectedHierarchyFilter(hierarchyFilter.items, skipFirstLevelAndLabel);
            if (selectedHierarchyFilterArray) {
                _this.markSelectedFilters(hierarchyDropdowns, selectedHierarchyFilterArray);
            }
            return hierarchyDropdowns;
        };
        this.recursivelyBuildFilterDropdownsFromHierarchyTree = function (tree, selectedHierarchyFilterArray, accumulator, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel) {
            if (!selectedHierarchyFilterArray || selectedHierarchyFilterArray.length === 0) {
                return;
            }
            var nextLevelTree = tree;
            var dropdownModel = {
                guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
                isCollapsed: false,
                title: _this.getTitleFromMap(selectedHierarchyFilterArray.length, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel),
                typeAlias: hierarchyTypeAlias,
                value: _this.getTitleFromMap(selectedHierarchyFilterArray.length, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel + selectedHierarchyFilterArray.length),
            };
            for (var _i = 0, selectedHierarchyFilterArray_1 = selectedHierarchyFilterArray; _i < selectedHierarchyFilterArray_1.length; _i++) {
                var selectedFilter = selectedHierarchyFilterArray_1[_i];
                nextLevelTree = nextLevelTree[selectedFilter].items;
            }
            var dropdownOptions = [];
            for (var option in nextLevelTree) {
                if (!nextLevelTree.hasOwnProperty(option)) {
                    continue;
                }
                var _a = nextLevelTree[option], _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                var parsedTitle = title.split(TITLE_SEPARATOR).pop();
                dropdownOptions.push({ title: parsedTitle, value: value, selected: false, documentsCount: 1 });
            }
            if (dropdownOptions.length > 0) {
                dropdownModel.items = dropdownOptions;
                accumulator.unshift(dropdownModel);
            }
            selectedHierarchyFilterArray.pop();
            _this.recursivelyBuildFilterDropdownsFromHierarchyTree(tree, selectedHierarchyFilterArray, accumulator, selectedSegment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel);
        };
        this.markSelectedFilters = function (hierarchyDropdowns, selectedHierarchyFilterArray) {
            if (!selectedHierarchyFilterArray || selectedHierarchyFilterArray.length === 0) {
                return;
            }
            for (var i = 0; i < selectedHierarchyFilterArray.length; i++) {
                if (!hierarchyDropdowns[i]) {
                    continue;
                }
                var items = hierarchyDropdowns[i].items;
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    var lastItemValue = item.value.split(HIERARCHY_SEPARATOR).pop();
                    if (lastItemValue === selectedHierarchyFilterArray[i]) {
                        item.selected = true;
                        break;
                    }
                }
            }
        };
        this.getSelectedHierarchyFilter = function (filters, skipFirstLevelAndLabel) {
            for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
                var filter = filters_1[_i];
                if (filter.selected) {
                    var selectedHierarchy = filter.value.split(HIERARCHY_SEPARATOR);
                    skipFirstLevelAndLabel && selectedHierarchy.shift(); // Removes first element from array, mutation
                    return selectedHierarchy;
                }
            }
            return null;
        };
        this.parseHierarchy = function (hierarchyFilter, skipFirstLevelAndLabel) {
            var hierarchyTree = {};
            for (var _i = 0, _a = hierarchyFilter.items; _i < _a.length; _i++) {
                var filterItem = _a[_i];
                var splittedFilterValue = filterItem.value.split(HIERARCHY_SEPARATOR);
                if (splittedFilterValue && splittedFilterValue.length) {
                    _this.addElementToTree(hierarchyTree, splittedFilterValue, filterItem);
                }
            }
            if (skipFirstLevelAndLabel && Object.keys(hierarchyTree).length) {
                hierarchyTree = hierarchyTree[Object.keys(hierarchyTree)[0]].items;
            }
            return hierarchyTree;
        };
        this.getHierarchyFilterLevel = function (filterValue) {
            return filterValue.split(HIERARCHY_SEPARATOR).length;
        };
        this.getAllowedDocumentsFilters = function (filters) {
            var result = filters;
            if (filters) {
                result = filters.filter(function (element) {
                    return ALLOWED_DOCUMENTS_FILTERS.indexOf(element.value) >= 0;
                });
            }
            return result;
        };
        this.isSelectedTypeWithHierarchy = function (selectedType) {
            var selectedTypeValue = SearchResultsService_1.SearchResultsService.getFilterValueItself(selectedType);
            return (selectedTypeValue === FullTextSearchApi_1.FullTextSearcherTypes.Course ||
                selectedTypeValue === FullTextSearchApi_1.FullTextSearcherTypes.Documentation ||
                selectedTypeValue === FullTextSearchApi_1.FullTextSearcherTypes.Drawings ||
                selectedTypeValue === FullTextSearchApi_1.FullTextSearcherTypes.Download);
        };
        this.getHierarchyFilterIndex = function (filters, filterGroupTypeAlias) {
            if (!filters) {
                return -1;
            }
            for (var i = 0; i < filters.length; i++) {
                var filter = filters[i];
                if (filter.typeAlias === filterGroupTypeAlias) {
                    return i;
                }
            }
            return -1;
        };
        this.addElementToTree = function (tree, splittedFilterValue, filter) {
            var currentValue = splittedFilterValue.shift();
            if (splittedFilterValue.length === 0) {
                tree[currentValue] = filter;
                tree[currentValue].items = {};
                return;
            }
            if (!tree[currentValue]) {
                tree[currentValue] = {};
                tree[currentValue].items = {};
            }
            _this.addElementToTree(tree[currentValue].items, splittedFilterValue, filter);
        };
        /**
         * Use to get value from dictionary
         * Logic for diffrent cases:
         * 1) for Course type -> return hierarchyDictionaryLabel
         * 2) for product hierarchy (dhs segment, Documentation type) ->
         * use getProductHierarchyTitle method (dictionary items - dhsProductHierarchyLevel1Label, ...),
         * 3) for marketing hierarchy (Documentation type) ->
         * use getHierarchyTitle method (dictionary items - level, productGroup, ...)
         */
        this.getTitleFromMap = function (index, segment, dictionary, hierarchyTypeAlias, hierarchyDictionaryLabel) {
            if (hierarchyDictionaryLabel) {
                return "".concat(hierarchyDictionaryLabel);
            }
            if (hierarchyTypeAlias === FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy) {
                var hierarchyLevel = index + 1;
                return _this.getProductHierarchyTitle(hierarchyLevel, segment, dictionary);
            }
            return _this.getHierarchyTitle(index, segment, dictionary);
        };
        this.getProductHierarchyTitle = function (level, segment, dictionary) {
            var segmentValue = SearchResultsService_1.SearchResultsService.getFilterValueItself(segment);
            var levelLabel = "".concat(segmentValue, "ProductHierarchyLevel").concat(level, "Label");
            return dictionary[levelLabel] ? dictionary[levelLabel] : "".concat(DEFAULT_LEVEL_LABEL, " ").concat(level);
        };
        this.getHierarchyTitle = function (index, segment, dictionary) {
            var levelLabel = dictionary.level ? dictionary.level : DEFAULT_LEVEL_LABEL;
            levelLabel += " ".concat(index + 1);
            if (segmentHierarchyMap[segment] &&
                segmentHierarchyMap[segment][index] &&
                dictionary[segmentHierarchyMap[segment][index]]) {
                return dictionary[segmentHierarchyMap[segment][index]];
            }
            return levelLabel;
        };
    }
    return HierarchyService;
}());
var service = new HierarchyService();
exports.HierarchyService = service;
